import { render, staticRenderFns } from "./CreateGameModal.vue?vue&type=template&id=f0a295da&scoped=true&"
import script from "./CreateGameModal.vue?vue&type=script&lang=ts&"
export * from "./CreateGameModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGameModal.vue?vue&type=style&index=0&id=f0a295da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a295da",
  null
  
)

export default component.exports